<template>

  <div
    :class="{'box-loading': loading}">
    <div class="form-group">
      <SelectQuestionform
        v-model="value.questionform_id"
        :placeholder="$t('Select a quentionnaire')" />
    </div>

    <div
      v-if="value.questionform_id"
      class="form-group">
      <div class="row">
        <label class="col-sm-3">{{ $t('Send when') }}:</label>
        <div class="col-sm-9">
          <div class="form-check">
            <input
              class="form-check-input"
              type="radio"
              name="send_type"
              id="send_type1"
              value="immediately"
              v-model="value.send_type">
            <label class="form-check-label" for="send_type1">
              {{ $t('Immediately') }}
            </label>
          </div>
          <div class="form-check">
            <input
              class="form-check-input"
              type="radio"
              name="send_type"
              id="send_type2"
              value="schedule"
              v-model="value.send_type">
            <label class="form-check-label" for="send_type2">
              {{ $t('Schedule') }}
            </label>
          </div>
          <ValidateMessage :error="validateErrors.send_type" />

          <div
            class="mt-3"
            v-if="value.send_type === 'schedule'">
            <DelayForm
              v-model="value.send_at" />
            <ValidateMessage :error="validateErrors.send_at" />
          </div>

        </div>
      </div>
    </div>

    <button
      class="btn btn-primary"
      type="button"
      :disabled="!value.questionform_id"
      @click="createQuestionnaireInvite()">{{ $t('Send') }}</button>
  </div>

</template>

<script>
import SelectQuestionform from '@/components/Fields/SelectQuestionform'
import DelayForm from '@/components/Parts/DelayForm'

export default {
  name: 'CandidateQuestionnaireInvite',
  components: {
    SelectQuestionform,
    DelayForm
  },
  props: {},
  data () {
    return {
      loading: false,
      value: {
        questionform_id: null,
        send_type: 'immediately',
        send_at: null
      },
      validateErrors: {}
    }
  },
  computed: {
    candidate () {
      return this.$store.getters.getCandidate
    },
    selectedJob () {
      return this.$store.getters.getCandidateSelectedJob
    }
  },
  created () {
  },
  methods: {
    alertNoCredits () {
      this.$store
      .dispatch('setAlertModal', {
        type: 'ok',
        title: 'Sem créditos para envio de convite de avaliação.',
        message: 'Contate o administrador.'
      })
    },
    /*
    createQuestionnaireInvite
    */
    createQuestionnaireInvite () {
      this.loading = true

      return this.$store
      .dispatch('createQuestionnaireInvite', {
        candidate_id: this.candidate._id,
        job_id: this.selectedJob._id,
        ...this.value
      })
      .then((response) => {
        this.$store.dispatch('refreshSelectQuestionnaireInvites')
        this.loading = false
        this.validateErrors = {}
        this.value = {
          questionform_id: null,
          send_type: 'immediately',
          send_at: null
        }
      })
      .catch((err) => {
        this.loading = false
        if (err.response.data.name === 'ValidationError') {
          this.validateErrors = err.response.data.errors
        }
        if (err.response.data.name === 'Forbidden') {
          this.alertNoCredits()
        }
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Candidate/Questionnaire/CandidateQuestionnaireInvite.vue